<script setup>
import {
    BookmarkIcon,
    CloudArrowDownIcon,
    HomeIcon,
    MagnifyingGlassIcon,
    UserCircleIcon,
} from '@heroicons/vue/24/outline'
import {Link, usePage} from "@inertiajs/vue3";
import {useWpaInstallStore} from "@/Stores/WpaInstallStore";

const pwaInstallStore = useWpaInstallStore();
</script>

<template>
	<nav class="max-w-xl mx-auto flex justify-evenly">
		<Link :class="{'animate-selected' : route().current('homepage')}" :href="route('homepage')" aria-label="Homepage"
		      cache-for="30s"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300 " prefetch="mount">
			<HomeIcon class="h-8"/>
		</Link>

		<Link :class="{'animate-selected' : route().current('discover')}" :href="route('discover')" aria-label="Discover Posts and Creators"
		      cache-for="5m"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300 " prefetch="mount">
			<MagnifyingGlassIcon class="h-8"/>
		</Link>

		<button v-if="pwaInstallStore.enabled" aria-label="Download App"
		        class=" p-4 w-full h-full flex items-center justify-center text-dark-300 "
		        @click="pwaInstallStore.showInAppInstallPromotion('Menu Bounce - Green')">
			<CloudArrowDownIcon class="h-8 text-green-600 animate-bounce"/>
		</button>

		<Link :class="{'animate-selected' : route().current('collection.index')}" :href="route('collection.index')" aria-label="Collections"
		      cache-for="5m"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300 " prefetch="mount">
			<BookmarkIcon class="h-8"/>
		</Link>

		<!-- <a v-if="!usePage().props.telegram.connected" :href="route('telegram.connect')" aria-label="Connect to Telegram Bot" class="p-4 w-full h-full flex items-center justify-center text-blue-500"
		   target="_blank" @click="telegramIconClick">
			<img alt="Telegram Logo" class="h-8" src="/images/telegram.svg" />
		</a> -->

		<Link v-if="usePage().props.auth.user" :class="{'animate-selected' : route().current('profile.index')}" :href="route('profile.index')"
		      aria-label="My Account" cache-for="5m"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300 " prefetch="mount">
			<UserCircleIcon class="h-8"/>
		</Link>
		<Link v-else :class="{'animate-selected' : route().current('login')}" :href="route('login')" aria-label="Login/Register"
		      cache-for="5m"
		      class="p-4 w-full h-full flex items-center justify-center text-dark-300" prefetch="mount">
			<UserCircleIcon class="h-8"/>
		</Link>
	</nav>
</template>
